import { fetchBatchCaseCalculations,resetProjectHeader, getProjectAndAffiliations, resetProjectsCache, updateProjectAndAffiliationsRequest } from "../../../store/calculation/calculation-input/ProjectHeaderSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks"

const useProjectHeaderFacade = () => {
    const dispatch = useAppDispatch();
    const getProjectAndAffiliationsDetails = (id: string) => {
        return dispatch(getProjectAndAffiliations(id));
    };
    const updateResetProjectHeader = () => {
            return dispatch(resetProjectHeader());
        };

    const fetchBatchProjectCalculations = (ids: Array<string>) => {
        return dispatch(fetchBatchCaseCalculations(ids));
    };

    const resetProjectsCacheStore = () => {
        return dispatch(resetProjectsCache(null));
    };

    const updateProjectAffiliations = (data: any) => {
        return dispatch(updateProjectAndAffiliationsRequest(data));
    };

    return {
        getProjectAndAffiliationsDetails,
        updateResetProjectHeader,
        resetProjectsCacheStore,
        fetchBatchProjectCalculations,
        updateProjectAffiliations,
    };
};

export default useProjectHeaderFacade;

